import { ENVIRONMENT } from './../config/config';
import { getCookieValue } from 'shared';

export const getAuthToken = () => {
  return getCookieValue(`${ENVIRONMENT}2_yepic_access_token`);
};
